import React from 'react'
import { Box, styled } from '@mui/material'
import Typography from './Typography'
import TestIds from '../testIds'

const TitleContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}))

const Subtitle = styled(Typography)``
const Title = styled(Typography)({
  '@media (max-width: 390px)': {
    fontSize: `calc(36 * calc(100vw / 390))`,
  },
})

const Text = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '4px',
  },
}))

const Inline = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`

interface Props {
  title: string
  subTitle?: string
  statusChip: React.ReactNode
  text?: React.ReactNode
}

export const StatusHeader = ({ title, statusChip, subTitle, text }: Props) => {
  return (
    <TitleContainer data-testid={TestIds.components.statusHeader.container}>
      <Inline>
        {subTitle && (
          <Subtitle variant='body2' color='grey800' data-testid={TestIds.components.statusHeader.subtitle}>
            {subTitle}
          </Subtitle>
        )}
        {statusChip}
      </Inline>
      <Title variant='display' color='primary500' data-testid={TestIds.components.statusHeader.title}>
        {title}
      </Title>
      {text && <Text data-testid={TestIds.components.statusHeader.text}>{text}</Text>}
    </TitleContainer>
  )
}
